export const NONE = '/404';
export const LOGIN = '/login';
export const CALLBACK = '/callback';
export const HOME = '/';
export const FORBIDDEN = '/403';
export const NOTFOUND = '/404';

export const BUSINESSTYPE = '/businessType'
export const CUSTOMERMANAGEMENT = '/customerManagement'
export const CUSTOMERMASTERDATA = '/customerMasterData'
export const APIMANAGEMENT = '/apiManagement'
export const DATATARGET = '/dataTarget'
export const DATASOURCE = '/dataSource'
export const AZUREAPPREGISTRATION = '/azureAppRegistration'
export const AZUREKEYVAULT = '/azureKeyVault'
export const MAPPINGMANAGEMENT = '/mappingManagement'  /*mapping*/
export const MESSAGEMANAGEMENT = '/messageManagement'
export const MESSAGEDETAILS = '/messageDetails'
export const INDEXMANAGEMENT = '/indexManagement'
export const TRANSPORTATION = '/transportation'
export const MASSRESEND = '/massResend'
export const UPLOADDATARESOURCE = '/uploadDataResource'
export const STREAMMANAGEMENT = '/streamManagement'
export const JOBMANAGEMENT = '/job'
export const GROOVYMANAGEMENT = '/groovyManagement'
export const REPORTEBILLING = '/reportEBilling'
export const REPORTORDER = '/reportOrder'
export const PERMISSIONMANAGEMENT = '/permissionManagement'  /*permission*/
export const USERMANAGEMENT = '/userManagement'  /*permission*/
export const ROLEMANAGEMENT = '/roleManagement'  /*permission*/
export const APPROVEPERMISSION = '/approvePermission'
export const WEBEDI = '/webEDI';
export const SHIPTO = '/shipTo';
export const USEREMAILMANAGEMENT = '/userEmailManagement';

export const MESSAGEPAYLOAD = '/messagePayload'
export const INDEXSEARCH = '/indexSearch'
export const CONNECTIONMONITOR = '/connectionMonitor'

// 0621
export const FORMULAINFO = '/formulaInfo'
export const FORMULATYPE = '/formulaType'

// export const RULESMANAGEMENT = '/rulesManagement'
export const EMAILMANAGEMENT = '/emailManagement'
export const CHATBI = '/chat'
export const HARNESS = '/harness'

export const AUDITLOGS = '/auditLogs'

export const REPORTMANAGEMENT = '/reportManagement'
export const REPORTTAG = '/reportTag'
export const REPORTPAGE = '/reportPage'
export const PBIREPORTPAGE = '/pbiReportPage'
export const REPORTPAGE_WITH_ID = '/reportPage/:id'
export const PBIREPORTPAGE_WITH_ID = '/pbiReportPage/:id'

export const DATAFLOWMONITORINGCONFIG = '/dataFlowMonitoringConfig' 
export const DATAFLOWLOG = '/dataFlowLog' 

export const MARKETINGGROUPMANAGEMENT = '/marketingGroupManagement' 
export const RESOURCEPOOL = '/resourcePool' 
export const ADDRESSBOOK = '/addressBook' 
export const SHORTLINK = '/shortLink' 
export const SMS = '/sms' 
export const SMSSIGNATURE = '/smsSignature' 
export const SMSTEMPLATE = '/smsTemplate' 
export const SMSMANAGEMENT = '/smsManagement' 
export const SMSMANAGEMENTDETAILS = '/smsManagementDetails'
export const EMAILSEND = '/emailSend'
export const EMAILADDRESS = '/emailAddress'
export const EMAILTEMPLATE = '/emailTemplate'
export const EMAILSENDONLINE = '/emailSendOnline'
export const EMAILLIST = '/emailList'
export const FATIGUECONFIG = '/fatigueConfig'
export const MANUALCALL = '/manualCall'
export const REMARKTEMPLATELIST = '/remarkTemplateList'
export const MANUALCALLMANAGEMENT = '/manualCallManagement'
export const INTELLIGENTCALL = '/intelligentCall'
export const INTELLIGENTCALLMODEL = '/intelligentCallModel'
export const INTELLIGENTCALLMANAGEMENT = '/intelligentCallManagement'
export const INTELLIGENTCALLDETAILS = '/intelligentCallDetails'

export const MICECADOEA = '/miceCadOea'
export const MICECADOEASCHEDULE = '/miceCadOeaSchedule'
export const THEMESETTING = '/themeSetting'


export const DRIVELIST = '/driveList'
export const DRIVEPERMISSION = '/drivePermission'
export const DRIVESEARCH = '/driveSearch'

export const TERMINOLOGYCONFIG = '/terminologyConfig'
export const SQLEXAMPLE = '/sqlExample'
export const QUERYAUDIT = '/queryAudit'
